import { ResponsiveContainer, Treemap } from "recharts"
import { PureComponent } from "react"

interface iPropsTreeChartSystemVolume {
    data: any[]
}

export default function TreeChartSystemVolume({data}:iPropsTreeChartSystemVolume) {
    
    interface iSistemas {
        ponto_digital: number
        ponto_apuracao: number
        colaboradores: number
        comunicados: number
        fale_conosco: number
        ronda_qrcode: number
        despesas: number
        documentos: number
        nfs: number
        auth: number
        holerite: number
        outros: number
    }

    function definirSistemas(dados:any[]):iSistemas {
        let sistemas:iSistemas = {
            ponto_digital: 0,
            ponto_apuracao: 0,
            colaboradores: 0,
            comunicados: 0,
            fale_conosco: 0,
            ronda_qrcode: 0,
            despesas: 0,
            documentos: 0,
            nfs: 0,
            auth: 0,
            holerite: 0,
            outros: 0,
        }

        for (let log of dados) {
            let url:string = log.url

            if (url.search("apuracao") > 0) {
                sistemas.ponto_apuracao++
                continue
            }

            if (url.search("login") > 0 || url.search("logoff") > 0 || url.search("device") > 0 || url.search("auth") > 0) {
                sistemas.auth++
                continue
            }

            if (url.search("holerite") > 0 || url.search("calculos") > 0 || url.search("calculo") > 0 || url.search("informe") > 0 || url.search("informes") > 0) {
                sistemas.holerite++
                continue
            }

            if (url.search("ponto") > 0 || url.search("escalas") > 0 || url.search("marcacoes") > 0 || url.search("solicitacoes") > 0 || url.search("servico") > 0 || url.search("ocorrencias") > 0 || url.search("ajuste") > 0 || url.search("ajustes") > 0) {
                sistemas.ponto_digital++
                continue
            }

            if (url.search("colaboradores") > 0) {
                sistemas.colaboradores++
                continue
            }

            if (url.search("comunicados") > 0) {
                sistemas.comunicados++
                continue
            }

            if (url.search("comunicacao") > 0) {
                sistemas.fale_conosco++
                continue
            }

            if (url.search("qrcode") > 0) {
                sistemas.ronda_qrcode++
                continue
            }

            if (url.search("despesas") > 0 || url.search("despesa") > 0) {
                sistemas.despesas++
                continue
            }

            if (url.search("documentos") > 0 || url.search("documento") > 0 || url.search("assinar") > 0) {
                sistemas.documentos++
                continue
            }

            if (url.search("nf") > 0 || url.search("nfs") > 0) {
                sistemas.nfs++
                continue
            }

            sistemas.outros++
        }

        return sistemas
    }

    function handleData(dados: any[]):any[] {
        let registros:any[] = []

        let sistemas:any = definirSistemas(dados)

        let sistemasRegistros: Array<any> = Object.keys(sistemas).map(key => {
            return { name: `${key}: ${sistemas[key]}`, value: sistemas[key] }
        });
        console.log(sistemasRegistros)

        for (let sistema of sistemasRegistros) {
            if (sistema.value === 0) {
                continue
            }
            registros.push(sistema)
        }

        registros.sort(function(a, b){return b.value-a.value});

        return registros
    }
    
    return (
        <div id="graph_system">
            <ResponsiveContainer width="100%" height="100%">
                <Treemap width={400} height={200} data={handleData(data)} dataKey="value" aspectRatio={4 / 3} stroke="#fff" fill="#8884d8" content={<CustomizedContent />} />
            </ResponsiveContainer>
        </div>
    )
}

const COLORS = ['#8889DD', '#9597E4', '#8DC77B', '#A5D297', '#E2CF45', '#F8C12D'];

class CustomizedContent extends PureComponent {
    render() {
      const { root, depth, x, y, width, height, index, name }:any = this.props;
  
      return (
        <g>
          <rect
            x={x}
            y={y}
            width={width}
            height={height}
            style={{
              fill: depth < 2 ? COLORS[Math.floor((index / root.children.length) * 6)] : '#ffffff00',
              stroke: '#fff',
            }}
          />
          <text x={x + width / 2} y={y + height / 2 + 7} textAnchor="middle" fill="#fff: 0" fontSize={14}>
              {name}
          </text>
        </g>
      );
    }
}